import axios from "axios";
import {toggleMicrocart} from "./microcart";

const EVENT_QUANTITY_UPDATED = "quantity.updated";

export const quantitiesInit = (quantity, toggleMicrocartEnabled) => {
    const input = quantity.querySelector(".js-quantity-input");
    const minQty = quantity.querySelector(".js-quantity-min");
    const plusQty = quantity.querySelector(".js-quantity-plus");
    const removeQty = quantity.querySelector(".js-quantity-remove");
    const $errorMessage = quantity.querySelector(".js-addtocart-error");

    if (minQty && plusQty) {
        const updateQuantity = (value) => {
            if (value === 0) {
                axios
                    .post("/cart/change.js", {
                        id: input.dataset.key,
                        quantity: value,
                    })
                    .then(function (response) {
                        input.value = value;
                        minQty.disabled = false;
                        plusQty.disabled = false;

                        window.dispatchEvent(new CustomEvent(EVENT_QUANTITY_UPDATED, { 'detail': response.data }));

                        if (toggleMicrocartEnabled) {
                            toggleMicrocart(true);
                        }
                    })
                    .catch(function (error) {
                        const errorMessage = error.response.data;
                        const errorHtml = '<div>' + errorMessage.message + '</div>';
                        $errorMessage.classList.remove('d-none');
                        $errorMessage.innerHTML = errorHtml;
                    });

            } else {
                axios
                    .post("/cart/change.js", {
                        id: input.dataset.key,
                        quantity: value,
                    })
                    .then(function (response) {
                        input.value = value;
                        minQty.disabled = false;
                        plusQty.disabled = false;

                        if (response.data.items) {
                            updateCurrentInput(response.data.items);
                        }

                        window.dispatchEvent(new CustomEvent(EVENT_QUANTITY_UPDATED, { 'detail': response.data }));

                        if (toggleMicrocartEnabled) {
                            toggleMicrocart(true);
                        }
                    })
                    .catch(function (error) {
                        const errorMessage = error.response.data;
                        const errorHtml = '<div>' + errorMessage.message + '</div>';
                        $errorMessage.classList.remove('d-none');
                        $errorMessage.innerHTML = errorHtml;
                    });
            }
        };

        const updateCurrentInput = (items) => {
            if (items.some(item => item.key === input.dataset.key)) {
                return;
            }

            // Only adopt a new key when the variant backs a single line, because bundles can put
            // several lines behind the same variant and we would pick up another line's key.
            const matchingItems = items.filter(item => item.id === +input.dataset.id);

            if (matchingItems.length === 1) {
                input.dataset.key = matchingItems[0].key;
            }
        };

        minQty.addEventListener("click", () => {
            minQty.disabled = true;
            setTimeout(() => {
                updateQuantity(+input.value - 1, minQty);
            }, 500);
        });

        plusQty.addEventListener("click", () => {
            plusQty.disabled = true;

            setTimeout(() => {
                updateQuantity(+input.value + 1);
            }, 500);
        });

        input.addEventListener("blur", () => {
            setTimeout(() => {
                updateQuantity(input.value);
            }, 500);
        });

        removeQty.addEventListener("click", (e) => {
            setTimeout(() => {
                updateQuantity(0);
            }, 500);
        });
    }
}